import axios from "axios";
import { getPEAISummary } from "../Config/config";

export const fetchAISummary = async (id) => {
  try {
    const response = await axios.post(
      `${getPEAISummary}/${id}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.log(error, "Error Generating AI Summary");
    throw error;
  }
};